module.exports = __webpack_public_path__ + "assets/images/amira_review_student_alert_modal_open.7688e3dd6948b35ed97be9a7e4622909.svg";